import { RootState } from '../store'

export const companySelector = (state: RootState) => {
  const { company } = state

  return company
}
